<template>
  <div>
    <div class="parent">
      <v-card>
        <div class="right-side">
          <div
            class="rotated"
            :style="[
              showedit
                ? { width: '464px', 'transform-origin': '232px 232px' }
                : { width: '388px', 'transform-origin': '194px 194px' },
            ]"
          >
            {{ homeRequest.Type == 1 ? "اجاره" : "خرید  " }}
          </div>
        </div>
        <div class="left-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ homeRequest.StateString }}
            </div>
          </v-card-title>
          <div>
            <app-row
              icon="hashtag"
              title="شماره پیگیری:"
              :value="homeRequest.FSerial"
            />
            <app-row
              icon="user"
              title="درخواست کننده:"
              :value="homeRequest.Name"
            />
            <app-row icon="money-bill" title="مبلغ:" :value="cost" />
            <app-row icon="calendar-alt" title="تاریخ:" :value="dateRange" />
            <app-row icon="user" title="ضامن 1:" :value="guarantor1" />
            <app-row icon="user" title="ضامن 2" :value="guarantor2" />
          </div>
          <template v-if="showedit">
            <div v-if="homeRequest.Removable == 1">
              <v-btn
                color="red white--text"
                rounded
                @click="$emit('cancel', homeRequest.FSerial, homeRequest.Type)"
              >
                {{ homeRequest.Type == 1 ? "فسخ قرارداد" : "لغو قرارداد" }}
              </v-btn>
              <v-btn
                v-if="homeRequest.canEdit == 1"
                color="primary white--text"
                rounded
                @click="$emit('edit', index)"
              >
                ویرایش قرارداد
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                color="red white--text"
                rounded
                @click="
                  $emit(
                    'confirm',
                    homeRequest.FSerial,
                    homeRequest.Type,
                    0,
                    '',
                    ''
                  )
                "
              >
                رد ضمانت </v-btn
              ><v-btn
                color="primary white--text"
                rounded
                @click="
                  $emit(
                    'confirm',
                    homeRequest.FSerial,
                    homeRequest.Type,
                    1,
                    homeRequest.Name,
                    homeRequest.Address
                  )
                "
              >
                تایید ضمانت
              </v-btn>
            </div>
          </template>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["homeRequest", "showedit", "index"],
  components: {
    appRow: DetailRow,
  },
  methods: {
    findStatus(status) {
      switch (status) {
        case 0:
          return "تایید نکرده";
        case 1:
          return "تایید کرده";
      }
      return "بررسی نکرده";
    },
  },
  computed: {
    cost() {
      if (this.homeRequest.Type == 1) {
        return (
          "رهن: " +
          this.numberWithCommas(this.homeRequest.Cash) +
          " ریال، اجاره: " +
          this.numberWithCommas(this.homeRequest.Rent) +
          " ریال"
        );
      } else {
        return this.numberWithCommas(this.homeRequest.Cash) + " ریال";
      }
    },
    dateRange() {
      if (this.homeRequest.Type == 1) {
        return (
          "از " + this.homeRequest.StartDate + " تا " + this.homeRequest.EndDate
        );
      } else {
        return this.homeRequest.StartDate;
      }
    },
    guarantor1() {
      return (
        this.homeRequest.G1Name +
        " (" +
        this.findStatus(this.homeRequest.Guarantor1Confirm) +
        ")"
      );
    },
    guarantor2() {
      return (
        this.homeRequest.G2Name +
        " (" +
        this.findStatus(this.homeRequest.Guarantor2Confirm) +
        ")"
      );
    },
    style() {
      var color = "";
      const isOwner =
        this.homeRequest.SrlStd == this.$store.getters.userInfo.StudentID;
      const isBuy = this.homeRequest.Type == 2;

      if (isOwner && isBuy) {
        color = "D0F0C0";
      } else if (!isOwner && isBuy) {
        color = "50c878";
      } else if (isOwner && !isBuy) {
        color = "e0cefc";
      } else {
        color = "bbadff";
      }

      return  "color: black;" + "background-color: #" + color;
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 0px 0px 0px !important;
}

.v-card {
  display: flex !important;
}

.halfPage {
  padding: 15px;
  text-align: center;
}
.v-btn {
  width: 150px;
  margin: 20px;
  float: left;
}
</style>
